module.exports = __webpack_public_path__ + "static/media/jonathan-smith-142050-unsplash-sm.913ef6a5.jpg";